import $ from 'jquery'
import inView from 'in-view'

export default {
  init() {
    inView('.slide-up').on('enter', el => {
      $(el).addClass('in-view');
      setTimeout(() => {
        $(el).removeClass('slide-up slide-up--delay in-view');
      }, 600)
    })
  },
  check() {
    this.init()
    inView('.slide-up').check()
  }
}
